import React, { useState } from 'react';
import { ArrowRight, Check } from 'lucide-react';
import { solutions } from '../mock';

const Solutions = () => {
  const [active, setActive] = useState(solutions[0].id);
  const current = solutions.find((s) => s.id === active);

  return (
    <section id="solutions" className="bg-black scroll-mt-24">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-24 lg:py-32">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-10">
          <div>
            <p className="text-[13px] uppercase tracking-[0.18em] text-neutral-500">Solutions</p>
            <h2 className="mt-3 text-[30px] sm:text-[40px] lg:text-[56px] leading-[1.04] sm:leading-[1.02] tracking-[-0.02em] font-semibold text-white max-w-2xl">
              Business-critical challenges. <span className="italic font-light text-neutral-400">Transformational impact.</span>
            </h2>
          </div>
          <a href="#" className="inline-flex items-center gap-2 text-[14px] font-medium text-white group">
            See all solutions
            <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" />
          </a>
        </div>

        <div className="flex flex-wrap gap-2 border-b border-neutral-900 pb-4">
          {solutions.map((s) => (
            <button
              key={s.id}
              onClick={() => setActive(s.id)}
              className={`px-4 py-2 rounded-full text-[13.5px] font-medium transition-colors ${active === s.id ? 'bg-white text-neutral-950' : 'text-neutral-300 hover:bg-neutral-900 border border-neutral-800'}`}
            >
              {s.title}
            </button>
          ))}
        </div>

        <div className="mt-10 grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <p className="text-[12px] uppercase tracking-wider text-neutral-500">{current.tag}</p>
            <h3 className="mt-2 text-[26px] sm:text-[32px] lg:text-[40px] leading-[1.05] tracking-tight font-semibold text-white">{current.title}</h3>
            <p className="mt-3 text-[17px] text-neutral-300">{current.tagline}</p>
            <a href="#" className="mt-6 inline-flex items-center gap-2 text-[14px] font-medium text-white group">
              Learn more
              <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" />
            </a>
          </div>
          <div className="lg:col-span-7 grid sm:grid-cols-3 gap-4">
            {current.bullets.map((b) => (
              <div key={b.heading} className="rounded-2xl border border-neutral-800 p-6 hover:border-blue-500 hover:bg-neutral-900/40 transition-all bg-neutral-950">
                <div className="w-8 h-8 rounded-md bg-white text-neutral-950 flex items-center justify-center">
                  <Check className="w-4 h-4" />
                </div>
                <h4 className="mt-4 text-[17px] font-semibold text-white">{b.heading}</h4>
                <p className="mt-2 text-[13.5px] text-neutral-400 leading-relaxed">{b.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Solutions;
